import { Injectable } from '@angular/core';
import { Tag } from '../models/tag.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TagsService {

  constructor(private http: HttpClient) { }

  searchTags(text: string, tagsPageNum: number) {
    const showBlocked = localStorage.getItem('showBlocked')
    const userId = JSON.parse(localStorage.getItem('user')).userId
    return this.http.get<{ tags: Tag[], nextPage: number }>(`api/tags/search?text=${text}&showBlocked=${showBlocked}&userId=${userId}&page=${tagsPageNum}`)
  }

}
